var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.414 2.85999C20.9365 2.33289 20.9327 1.48208 20.4056 0.959658C19.8785 0.437238 19.0277 0.441033 18.5052 0.968136L15.3746 4.12679C14.1041 5.40872 13.2297 6.28807 12.4888 6.88308C11.7691 7.46107 11.3068 7.65936 10.8928 7.71213C10.6328 7.74526 10.3698 7.74526 10.1098 7.71213C9.6958 7.65936 9.23352 7.46107 8.51382 6.88308C7.77291 6.28807 6.89851 5.40872 5.62797 4.12679L2.49737 0.968138C1.97495 0.441035 1.12415 0.437239 0.597043 0.95966C0.0699397 1.48208 0.0661439 2.33289 0.588564 2.85999L3.77555 6.07555C4.97587 7.28666 5.9569 8.27652 6.831 8.9785C7.73996 9.70848 8.66256 10.2369 9.77001 10.3781C10.2556 10.44 10.747 10.44 11.2326 10.3781C12.34 10.2369 13.2626 9.70848 14.1716 8.9785C15.0457 8.27652 16.0267 7.28667 17.227 6.07556L20.414 2.85999Z",
    fill: "#090A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.92f2094e061ac97fa581d8a31ea3ec22.svg";
export { ForwardRef as ReactComponent };